import { Skeleton } from '../../components/skeleton/Skeleton';

export function OptionRowsSkeleton() {
  return <div aria-hidden="true" className="skeleton-stack" data-skeleton="OptionRowsSkeleton">{Array.from({ length: 3 }, (_, index) => <div key={index}><Skeleton variant="line" /></div>)}</div>;
}
